/**
 * Initialisation
 */  
var app = (function() {
    
    function App() {};
    
    App.prototype = {};
    
    return new App();
})();